var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.initializing
    ? _c(
        "div",
        { staticClass: "confirm-infos" },
        [
          _vm.isTrial
            ? [
                _c("p", [
                  _vm._v(
                    "\n      Your " +
                      _vm._s(_vm.trialDays) +
                      " days trial period is about to begin. You will have access to PM2 Plus\n      features and connect up to " +
                      _vm._s(_vm.plan.process_limit) +
                      " processes. You will be charged $" +
                      _vm._s(_vm.taxedPrice) +
                      "\n      / " +
                      _vm._s(_vm.plan.interval) +
                      " (tax included) once the trial is finished (on the " +
                      _vm._s(_vm.trialEndDate) +
                      "),\n      but you can cancel any time during your trial.\n    "
                  ),
                ]),
              ]
            : [
                _vm.plan.process_limit
                  ? _c("p", { staticClass: "mt-2" }, [
                      _vm._v("\n      Monitoring plan is for:"),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", { staticClass: "price-show" }, [
                        _vm._v(_vm._s(_vm.plan.process_limit) + " processes"),
                      ]),
                    ])
                  : _c("p", [
                      _vm._v(
                        "\n      You choose to cancel your subscription.\n    "
                      ),
                    ]),
                _vm._v(" "),
                _vm.isPremiumDowngrade
                  ? _c(
                      "h2",
                      [
                        _vm.currentTrialEndDate
                          ? [
                              _vm._v(
                                "\n        Your trial will be immediately canceled.\n      "
                              ),
                            ]
                          : _vm.periodEndDate
                          ? [
                              _vm._v(
                                "\n        Your bucket will be downgraded on " +
                                  _vm._s(_vm.periodEndDate) +
                                  ".\n      "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.coupon.valid
                  ? _c("h2", { staticClass: "mt-2" }, [
                      _vm._v(
                        "\n        Enjoy a reduced price of $" +
                          _vm._s(_vm.taxedPrice) +
                          " (tax included) per " +
                          _vm._s(_vm.plan.interval) +
                          "\n        " +
                          _vm._s(_vm.duration) +
                          "\n        "
                      ),
                      _vm.coupon.duration !== "forever"
                        ? _c("span", [
                            _vm._v(
                              "\n          and $" +
                                _vm._s(_vm.afterPrice) +
                                " per " +
                                _vm._s(_vm.plan.interval) +
                                " after that "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(".\n      "),
                    ])
                  : _vm.taxedPrice > 0
                  ? _c("p", { staticClass: "mt-2" }, [
                      _vm._v("\n        Price is:"),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", { staticClass: "price-show" }, [
                        _vm._v("$" + _vm._s(_vm.afterPrice)),
                      ]),
                      _vm._v(" "),
                      _vm.tax > 0
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.tax) + "% tax included)"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n        per "),
                      _c("b", { staticClass: "price-show" }, [
                        _vm._v(_vm._s(_vm.plan.interval)),
                      ]),
                      _c("br"),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "mt-1" }, [
                  _vm._v("\n          Card charged will be:\n          "),
                  _c("div", { staticClass: "credit-card-fake mt-1" }, [
                    _vm._v("\n            " + _vm._s(_vm.card.name)),
                    _c("br"),
                    _vm._v(
                      "\n            **** **** **** " +
                        _vm._s(_vm.card.last4) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "edit-card",
                    on: {
                      click: function ($event) {
                        return _vm.changeCard()
                      },
                    },
                  },
                  [_vm._v("Edit card")]
                ),
                _vm._v(" "),
                _c("p"),
              ],
          _vm._v(" "),
          _vm.loading
            ? _c("VProgressCircular", {
                staticClass: "mt-4",
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 24,
                  width: 4,
                },
              })
            : _c(
                "VBtn",
                {
                  staticClass: "button-next mt-4 mb-2",
                  staticStyle: { margin: "0 auto" },
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("submit")
                    },
                  },
                },
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.taxedPrice && !_vm.isTrial ? "Confirm" : "Continue"
                      )
                    ),
                  ]),
                ]
              ),
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("VProgressCircular", {
            staticClass: "my-4",
            attrs: { indeterminate: "", color: "primary", size: 32, width: 8 },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }